// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { checkTripEnds, checkTripStarts } from '@/_helper//checkTripStarts';
import { AppContext } from '@/context/AppContext';

// Styles
import './contactLayer.scss';

class ContactLayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            layerShow: false,
        };
        this.overlayRef = React.createRef();
    }

    static contextType = AppContext;

    checkServiceTimesOnPublicHolidays = () => {
        let currentDate = new Date().valueOf(),
            startDate = new Date('2024-12-22 00:01').valueOf(),
            endDate = new Date('2025-01-01 09:10').valueOf();

        return currentDate > startDate && currentDate < endDate;
    };

    show = () => {
        this.setState((prevState) => ({
            layerShow: true,
        }));
    };
    hide = () => {
        this.setState((prevState) => ({
            layerShow: false,
        }));
    };

    handleOutsideClick(ref) {
        document.addEventListener('mouseup', (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                this.setState((state) => {
                    state.layerShow = false;
                    return state;
                });
            }
        });
    }

    render() {
        this.handleOutsideClick(this.overlayRef);

        return (
            <div className="contact-layer-sec menu-item">
                <div onClick={this.show} className="contact-layer">
                    <i className="material-symbols-outlined">help</i>
                    <span className="title">Kontakt</span>
                </div>

                {this.state.layerShow && (
                    <div className="overlay" ref={this.overlayRef}>
                        <i className="material-symbols-outlined close" onClick={this.hide}>
                            close
                        </i>

                        <div className="section">
                            <div className="headline">
                                Noch Fragen?
                                <br />
                                Wir helfen Ihnen weiter
                            </div>
                            <div className="subline">
                                Unser{' '}
                                <a
                                    href={`${window.$website}/${
                                        this.context?.travelType === 'cruise' ? 'service/kreuzfahrt' : 'service'
                                    }`}
                                    rel="noopener noreferrer"
                                    target="_blank">
                                    FAQ
                                </a>{' '}
                                konnte Ihre Frage nicht beantworten?
                                <br />
                                Wenden Sie sich an unser Serviceteam.
                            </div>
                        </div>

                        {this.props.loggedIn && checkTripStarts() && !checkTripEnds() && (
                            <div className="section box">
                                <div className="row">
                                    <i className="material-symbols-outlined">phone_iphone</i>
                                    <div className="text-bold">
                                        Rufen Sie uns an
                                        <br />
                                        +49 (0) 89 99 82 99 531
                                    </div>
                                </div>

                                {this.checkServiceTimesOnPublicHolidays() ? (
                                    <>
                                        <div className="row">
                                            <div>
                                                Unser Service ist rund um die Uhr für Sie erreichbar. Nur während der
                                                Feiertage ändern sich die Öffnungszeiten wie folgt:
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div>
                                                24.12.2024 bis 16:30 Uhr
                                                <br />
                                                25.12.2024 ab 08:00 Uhr
                                                <br />
                                                31.12.2024 bis 20:00 Uhr
                                                <br />
                                                01.01.2025 ab 09:00 Uhr
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="row">
                                        <div> Wir sind rund um die Uhr für Sie erreichbar.</div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="section box">
                            <div className="row">
                                <i className="material-symbols-outlined">mail</i>
                                <div className="text-bold">Kontaktieren Sie unser Serviceteam</div>
                            </div>
                            <div className="row">
                                <div>Hier können Sie Ihre individuellen Fragen platzieren.</div>
                            </div>
                            <div className="row">
                                <a
                                    className="button"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={`${window.$website}/service/kontakt`}>
                                    Service anfragen
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ContactLayer;
